export const splitDetailConfig = {
    table: {
        clickState: false,
        height: 450,
        columns: [
            {
                label: '分账单号',
                prop: 'divideNo',
                width: '180px'
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                width: '180px'
            },
            {
                label: '供应商编码',
                prop: 'carrierCode',
                width: '180px'
            },
            {
                label: '供应商名称',
                prop: 'carrierName',
                width: '180px'
            },
            {
                label: '司机名称',
                prop: 'driver',
                width: '180px'
            },
            {
                label: '司机编码',
                prop: 'driverNo',
                width: '180px'
            },
            {
                label: '司机电话',
                prop: 'driverContactWay',
                width: '180px'
            },
            {
                label: '分账金额',
                prop: 'divideAmount',
                width: '180px'
            }
        ],
        actions: {},
        leftOperation: true,
        leftWidth: 240
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 100]
    }
};